import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4 rounded-lg border border-solid border-lightGray30 bg-white p-4 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-textPrimary" }, "Permite plantão ocupado sem identificação"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#68688D]" }, " Escalistas podem marcar plantões cobertos por terceiros (ex.: equipe CLT da Unidade) sem indicar o médico. Esses plantões não geram check, registro nem pagamento. ")
], -1)

import ToggleSwitch from '@/components/designSystem/Switch/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnidentifiedCoverageScheduleCard',
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(ToggleSwitch, {
      "model-value": _ctx.modelValue,
      disabled: _ctx.disabled,
      "data-testid": "schedule-unidentified-coverage-switch",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
    }, null, 8, ["model-value", "disabled"])
  ]))
}
}

})